import { Clock } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import StarRating from '@/components/StarRating';
import { cn } from '@/lib/utils';

export const TestimonialCard = ({ testimonial, onClick, className }) => {
  const thumbnailImage = testimonial.image_urls?.[0];
  
  return (
    <Card
      onClick={onClick}
      className={cn(
        'testimonial-card glass glass-hover border-white/5 overflow-hidden cursor-pointer group',
        className
      )}
      data-testid={`testimonial-card-${testimonial.id}`}
    >
      {thumbnailImage && (
        <div className="relative h-40 overflow-hidden">
          <img
            src={thumbnailImage}
            alt={testimonial.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
        </div>
      )}
      <CardContent className={cn('p-5', !thumbnailImage && 'pt-5')}>
        <div className="flex items-center justify-between mb-3">
          <StarRating rating={testimonial.rating} size="small" />
          <div className="flex items-center gap-1.5 text-xs text-zinc-400">
            <Clock className="w-3 h-3" />
            <span className="mono">{testimonial.time_to_finish}</span>
          </div>
        </div>
        
        <h3 className="font-semibold text-white mb-2 line-clamp-1 group-hover:text-primary transition-colors">
          {testimonial.title}
        </h3>
        
        <p className="text-sm text-zinc-400 line-clamp-2">
          {testimonial.description}
        </p>
        
        {testimonial.image_urls?.length > 1 && (
          <div className="flex items-center gap-1 mt-3 pt-3 border-t border-white/5">
            <div className="flex -space-x-2">
              {testimonial.image_urls.slice(1, 4).map((img, idx) => (
                <div
                  key={idx}
                  className="w-6 h-6 rounded border-2 border-[#0a0a0a] overflow-hidden"
                >
                  <img
                    src={img}
                    alt=""
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.parentElement.style.display = 'none';
                    }}
                  />
                </div>
              ))}
            </div>
            <span className="text-xs text-zinc-500 ml-2">
              +{testimonial.image_urls.length - 1} images
            </span>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TestimonialCard;
